var Vendd = (function (Vendd) {
    'use strict';

    Vendd.DataValidation = (function (DataValidation) {

        DataValidation.Messages = (function (Messages) {

        Messages.ValidationError = function (errors) {
            var data = {
                errors: errors,
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.DataValidation.Messages.ValidationError", data);
        };
        Messages.ValidationError.className = "Vendd.DataValidation.Messages.ValidationError";

        Messages.ValidationSuccess = function () {
            var data = {
                errors: {},
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.DataValidation.Messages.ValidationSuccess", data);
        };
        Messages.ValidationSuccess.className = "Vendd.DataValidation.Messages.ValidationSuccess";


        return Messages;

    })(DataValidation.Messages || {});

        return DataValidation;

    })(Vendd.DataValidation || {});

return Vendd;

})(Vendd || {});